import { MDBCol, MDBLink } from 'mdbreact';
import React from 'react';
import { MDBMask, MDBView } from 'mdbreact';
import { Box, Typography } from '@material-ui/core';

class HoverSubImage extends React.Component {

    render() {
        return (
                    <MDBCol sm="12" md='6' xl='3' style={{padding:"10px"}}>
                        <MDBLink to={this.props.page}>
                        <MDBView zoom waves>
                            <img 
                                src={this.props.image} 
                                className="img-fluid" 
                                alt=""
                                style={{}}/>
                            <MDBMask className="flex-center" overlay={this.props.overlay}>
                                <Typography variant="h1" className="white-text" style={{fontSize:"1rem"}} fontWeight='fontWeightBold'><Box fontWeight='fontWeightBold' textAlign="center">{this.props.text}</Box><br/><Box textAlign="center">{this.props.body}</Box></Typography>
                                {/* <Typography variant="p" className="black-text" className="align-bottom">{this.props.body}</Typography> */}
                            </MDBMask>
                        </MDBView>
                        </MDBLink>
                    </MDBCol>
        )
    }
}

export default HoverSubImage;